export const iconFontAwesomeUsersPeoplePersonWalkingArrowRight = (
	<i className="fa-solid fa-person-walking-arrow-right"></i>
);
